import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { EmployeeImportComponent, EmployeeImportSubmitEvent } from '../../components/employee-import/employee-import.component';
import {
  EmployeeImportsPageChangedEvent,
  EmployeeImportsTableComponent,
} from '../../components/employee-imports-table/employee-imports-table.component';
import { EmployeeImportResponse } from '../../employee.model';
import { EmployeeStore } from '../../employee.store';
import {SHARED_IMPORTS} from "../../../../shared/modules/shared-imports.module";

@Component({
  selector: 'app-employee-import-page',
  imports: [EmployeeImportComponent, EmployeeImportsTableComponent, ...SHARED_IMPORTS],
  templateUrl: './employee-import.page.html',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class EmployeeImportPage {
  protected readonly employeeStore = inject(EmployeeStore);

  constructor() {
    this.employeeStore.loadEmployeeImports();
  }

  protected importEmployees(event: EmployeeImportSubmitEvent): void {
    this.employeeStore.importEmployees(event.file, event.idempotencyKey);
  }

  protected retryImport(): void {
    this.employeeStore.retryLastImport();
  }

  protected refreshImports(): void {
    this.employeeStore.loadEmployeeImports({
      pageNumber: this.employeeStore.importsPageNumber(),
      pageSize: this.employeeStore.importsPageSize(),
    });
  }

  protected changePage(event: EmployeeImportsPageChangedEvent): void {
    this.employeeStore.loadEmployeeImports(event);
  }

  protected downloadImport(item: EmployeeImportResponse): void {
    this.employeeStore.downloadImportFile(item.id, item.originalFileName);
  }

  protected downloadImportErrors(item: EmployeeImportResponse): void {
    this.employeeStore.downloadImportErrors(item.id, item.originalFileName);
  }

  protected downloadImportSummary(item: EmployeeImportResponse): void {
    this.employeeStore.downloadImportSummary(item.id, item.originalFileName);
  }
}
